import { AxiosResponse } from 'axios';

import { api } from '../../http';
import {
  BaseFilter,
  DepartmentSchedules,
  EmployeesSchedules,
  PageRequest,
  PageResponse,
  Schedule,
  ScheduleWithSettings,
  Shift,
  ShiftToAdd,
  TreeNodeBase
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const ScheduleService = {
  getSchedules(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<PageResponse<Schedule> | undefined>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api
      .get<ApiResponse<PageResponse<Schedule>>>('schedule', {
        params: searchParams
      })
      .then((resp) => {
        if (resp.data.isSuccess) {
          // "Разворачиваем" в старую форму
          return { ...resp, data: resp.data.value };
        } else {
          // При ошибке возвращаем data: undefined (либо можно выбросить ошибку)
          return { ...resp, data: undefined };
        }
      });
  },

  getScheduleById(
    id: number
  ): Promise<AxiosResponse<ScheduleWithSettings | undefined>> {
    return api
      .get<ApiResponse<ScheduleWithSettings>>(`schedule/${id}`)
      .then((resp) => {
        if (resp.data.isSuccess) {
          return { ...resp, data: resp.data.value };
        } else {
          return { ...resp, data: undefined };
        }
      });
  },

  updateSchedule(
    id: number,
    schedule: ScheduleWithSettings
  ): Promise<AxiosResponse<ApiResponse<ScheduleWithSettings>>> {
    return api.put<ApiResponse<ScheduleWithSettings>>(
      `schedule/${id}`,
      schedule
    );
  },

  deleteSchedule(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`schedule/${id}`);
  },

  createSchedule(
    schedule: ScheduleWithSettings
  ): Promise<AxiosResponse<ApiResponse<ScheduleWithSettings>>> {
    return api.post<ApiResponse<ScheduleWithSettings>>('schedule', schedule);
  },

  getSchedulesForSelection(): Promise<
    AxiosResponse<ApiResponse<TreeNodeBase[]>>
  > {
    return api.get<ApiResponse<TreeNodeBase[]>>('schedule', {
      params: { ForSelection: 'true' }
    });
  },

  exportSchedule(
    params: {
      start: string;
      end: string;
      departmentId: number;
      timesheet: boolean;
      includeAbsences?: boolean;
      includeTasks?: boolean;
      includeTotalHours?: boolean;
    }
  ): Promise<AxiosResponse<Blob>> {
    const searchParams = new URLSearchParams();
    searchParams.append('start', params.start);
    searchParams.append('end', params.end);
    searchParams.append('departmentId', params.departmentId.toString());
    searchParams.append('timesheet', params.timesheet.toString());
    
    if (params.includeAbsences !== undefined) {
      searchParams.append('includeAbsences', params.includeAbsences.toString());
    }
    if (params.includeTasks !== undefined) {
      searchParams.append('includeTasks', params.includeTasks.toString());
    }
    if (params.includeTotalHours !== undefined) {
      searchParams.append('includeTotalHours', params.includeTotalHours.toString());
    }

    return api.get<Blob>('schedule/export', {
      params: searchParams,
      responseType: 'blob'
    });
  }
};
